import { FC, useState } from "react";
import { Button, Modal } from "react-bootstrap";

interface ConfirmChangePopupProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  disableTime?: number;
}

const ConfirmChangePopup: FC<ConfirmChangePopupProps> = ({
  show,
  onHide,
  onConfirm,
  title = "Confirm Selection",
  message = "Are you sure you want to make this change?",
  disableTime = 6000
}) => {
  const [loading, setLoading] = useState(true);
  useState(() => 
    setTimeout(() => {
      setLoading(false);
    }, disableTime)
  );
  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="fs-5 fw-semibold">
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={loading}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmChangePopup;
